import { createContext } from "react";

export type DomainBrandingContextValue = {
  loading: boolean;
  isError: boolean;
};

export const DomainBrandingContext = createContext<DomainBrandingContextValue>({
  loading: false,
  isError: false,
});
